import moment from 'moment'
export const formatData2Calendar = (data) => {
  let k, dataArr = []
  for (k in data) {
    dataArr.push({
      date: moment(k).format('YYYY-M-D'),
      course: data[k]
    })
  }
  return dataArr
}
